import {ReactNode} from 'react'

export const ServiceRequestTemplate = ({children, className = ''}: { children: ReactNode, className?: string }) => {
    return <div className={'service-request-form-page ' + className}>
        {children}
    </div>
}